module.exports = __webpack_public_path__ + "img/osmosis-light.899fd43d.svg";